import Http from "../http/backoffice";
import HttpPartner from "../http/partner";
import HttpPartnerIntegrations from "../http/partner-integrations";
import { serialize } from '@/util';


// LISTA DE CIDs
export const listCIDs = (params) =>
	Http.get(`/cid${serialize(params)}`);

// LISTA DE CPT's
export const listCpts = (params) =>
	HttpPartner.get(`/form/cpt${serialize(params)}`);

// TRIAGEM
export const listQuestions = () => Http.get(`/question`);
export const saveAnswers = (param) => Http.post(`/create/question/user`, param);
export const endMeeting = (param) =>
	Http.put(`/schedule/${param.id}/${param.scheduleId}`, param.body);
export const listAnswers = (param) =>
	Http.get(`/questions/${param.meetCode}/${param.userId}/${param.partner}`);
export const editAnswers = (param) =>
	Http.put(`/question/${param.meetCode}/${param.id}`, param.body);

// AVALIAÇÃO
export const saveEvaluation = (param) =>
	Http.post(`/create/sorting/user`, param);
export const listEvaluationAnswers = (param) =>
	Http.get(`/sorting/${param.meetCode}/${param.userId}/${param.partner}`);
export const editEvaluationAnswers = (param) =>
	Http.put(`/sorting/${param.meetCode}/${param.id}`, param.body);

// PRESCRIÇÃO
export const savePrescription = (param) =>
	Http.post(`/create/prescription/meets`, param);

// export const avaliation = (payload) =>
// 	HttpPartner.post(`meetings/avaliation/meets-code/${payload.meets}`, {
// 		...payload,
// 	});
export const listPrescriptionAnswers = (param) =>
	Http.get(
		`/prescription/file/meets/${param.meetCode}/${param.userId}/${param.partner}`
	);

export const listAllPrescriptions = (param) =>
	Http.get(`/all/prescriptions/${param.id}/${param.date}/${param.class}`);

export const listPatientFiles = (param) =>
	Http.get(`/patient/docs/${param.partner}?room=${param.room}`);

export const getDoctorMemedToken = (cpf) =>
	HttpPartnerIntegrations.get(`/memed/user-token/${cpf}`);

export const saveMemedPrescription = (params) =>
	HttpPartnerIntegrations.post(`/memed/prescription/${params.prescriptionId}`, params.body);

// ENVIAR MENSAGEM DE WPP PARA O PACIENTE
export const callBackPatient = (params) =>
	Http.post(`/dropConnection/notifications`, params);

// ENVIAR PRESCRIÇÃO AO PACIENTE
export const sendPrescription = (params) =>
	Http.post(`/prescription/file/${params.id}`, params.body);
